import { Transactions } from "./transaction";
import { RawTransactions } from "./transaction.types";

export const mockRawTransactions = (): RawTransactions => {
  return {
    totalResult: 1,
    transactions: [
      {
        accountingDate: "2025-03-20T03:00:00",
        actualId: "20250320030000_969696969696_SHIPOUT",
        centerCode: "9696",
        centerId: "124ca01b-d356-370a-ad4f-38982a5127c4",
        channel: "",
        collectionId: "",
        countryId: "ES",
        delegation: "028",
        deviceDetails: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          deviceName: "RRQAPunto_09",
          deviceCode: "969696969696",
          deviceManufacturer: "RRQAPunto_09",
          deviceModel: "RRQAPunto_09",
          deviceType: "Aceptadora",
          deviceIp: "1.1.1.1",
          devicePort: 8080,
          solutionType: "RRQAPunto_09",
          maxNoteCapacity: 200,
          maxCoinCapacity: 200,
          countryCode: "ES",
          currencies: ["EUR", "USD"],
          delegationCode: "028",
        },
        deviceId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        entity: {
          id: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
          name: "RRQAPunto_09",
          code: "969696",
          countryCode: "ES",
          imageLink:
            "https://emazgenkindstg03.z6.web.core.windows.net/img/entity/c28dee41-f883-3407-bd48-0ccb3bb5f719.png",
        },
        entityId: "c28dee41-f883-3407-bd48-0ccb3bb5f719",
        id: "41b99ed2-f5a5-4c12-bee3-eb6468700b31",
        origin: "COINACCEPTOR",
        receiptNumber: "52399",
        servicePoint: {
          id: "cd887371-8eab-313b-ade1-160c6d7a7329",
          isEarlyValue: false,
          name: "RRQAPunto_09",
          centerCode: "9696",
          centerName: "RRQAPunto_09",
        },
        servicePointCode: "96",
        servicePointId: "cd887371-8eab-313b-ade1-160c6d7a7329",
        strapSealCode: "",
        systemEntryDate: "",
        teller: "96969696969610011223",
        tellerLogin: "599617",
        tellerName: "QA Team",
        timeZone: "GMT+02:00",
        transactionDate: "2025-03-20T05:00:00",
        transactionInfo: "",
        transactionRef: "",
        transactionType: "SHIPOUT",
        hasAccreditation: false,
        hasNotification: false,
        amounts: [
          {
            id: "EUR_CASH",
            currency: "EUR",
            origin: "CASH",
            categories: ["CAT_4"],
            total: 130,
            numItems: 25,
            barCodes: [],
            accreditation: undefined,
            notification: undefined,
          },
        ],
        denominations: [
          {
            boxName: "COINACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            categoryStatus: "VALID",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 500,
            description: "",
            isValid: true,
            numItems: 24,
            origin: "CASH",
            subType: "",
            total: 12000,
            type: "NOTE",
          },
          {
            boxName: "COINACCEPTOR",
            barCode: "",
            cardNumber: "",
            category: "CAT_4",
            categoryStatus: "VALID",
            codeLine: "",
            collectionId: "",
            currency: "EUR",
            date: "",
            value: 1000,
            description: "",
            isValid: true,
            numItems: 1,
            origin: "CASH",
            subType: "",
            total: 1000,
            type: "NOTE",
          },
        ],
        extraDatas: [{ name: "URL", value: "Pdrm/jmsPdrm" }],
        currencies: [
          {
            exponent: -2,
            currency: "EUR",
          },
        ],
      },
    ],
  };
};

export const mockTransactions = (): Transactions => new Transactions(mockRawTransactions());
